import type { ClientEnv as EnvClientEnv } from "@repo/env/client"

// Re-export the type for backward compatibility
export type ClientEnv = EnvClientEnv

// This will be provided by the app using this package
let clientEnv: ClientEnv | undefined

export function initializeClientEnv(
  env: Pick<ClientEnv, "CONVEX_URL" | "CONVEX_SITE_URL"> & Partial<ClientEnv>,
) {
  // Validate that the required fields are present
  if (!env.CONVEX_URL || !env.CONVEX_SITE_URL) {
    throw new Error("Missing required environment variables: CONVEX_URL and CONVEX_SITE_URL")
  }
  // Ensure we have all fields (use empty strings for missing optional fields)
  clientEnv = {
    CLOUDFLARE_ACCOUNT_HASH: env.CLOUDFLARE_ACCOUNT_HASH || "",
    CLOUDFLARE_IMAGES_URL: env.CLOUDFLARE_IMAGES_URL || "",
    CONVEX_URL: env.CONVEX_URL,
    CONVEX_SITE_URL: env.CONVEX_SITE_URL,
  }
}

export function getClientEnv(): ClientEnv {
  if (!clientEnv) {
    throw new Error(
      "Client environment not initialized. Call initializeClientEnv() first in your app initialization.",
    )
  }
  return clientEnv
}
